module.exports = __webpack_public_path__ + "static/media/icon-512x512.1bcdaae0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hinkley/icon-512x512.png
// module id = 717
// module chunks = 0